<template>
  <div>
    <b-row>
      <b-col sm="12">
        <InputText title="Nome" field="name" :formName="formName" :required="true" :maxLength="50"
          v-model="typePayment.name" :markFormDirty="false" />
      </b-col>
      <b-col sm="6" v-if="hasRule('Billet')">
        <RadioGroup title="Emite Boleto?" field="type" :formName="formName" :options="[
          { text: 'Sim', value: true },
          { text: 'Não', value: false },
        ]" v-model="typePayment.isBankSlip" />
      </b-col>
      <b-col sm="6" v-if="options.length > 0 && hasRule('PDV')">
        <CheckboxGroup title="Módulo" field="module" :markFormDirty="false" :options="options"
          :initialValue="typePayment.module" v-model="typePayment.module" />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <div class="text-right">
          <Button _key="btnSavePaymentType" type="success" title="Salvar" :disabled="!isFormValid(formName)"
            classIcon="fas fa-save" size="medium" :clicked="saveTypePayment" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputText from "@/ui/forms/InputText";
import RadioGroup from "@/ui/forms/RadioGroup.vue";
import Button from "@/ui/forms/Button";
import CheckboxGroup from "@/ui/forms/CheckboxGroup";

import TypePayment from "../../models/TypePayment";
import TypePaymentService from "../../services/typePayment.service";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "TypePaymentCreateUpdate",
  props: {
    registerInSelect: Boolean,
    value: Object,
  },
  components: { InputText, RadioGroup, Button, CheckboxGroup },
  data() {
    return {
      formName: "typePaymentCreateUpdate",
      typePayment: new TypePayment(),
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
    ...mapGetters("user", ["hasRule"]),
    options() {
      let final = [];

      let options = [
        { text: "PDV", value: "PDV" },
        { text: "Locação", value: "Rental" },
      ];

      options.forEach((item) => {
        if (item.value == "Rental" && this.hasRule("Rental")) final.push(item);
        if (item.value == "PDV" && this.hasRule("PDV")) final.push(item);
      });

      return final;
    },
  },
  methods: {
    ...mapMutations("generic", [
      "addEvent",
      "removeLoading",
      "removeEvent",
      "hideModal",
      "hideVodal",
    ]),
    ...mapMutations("validation", ["resetValidation"]),
    async saveTypePayment() {
      try {
        if (this.typePayment.id) {
          const response = await TypePaymentService.update(this.typePayment);
          if (response.success) {
            this.addEvent({ name: "typePaymentSaved" });
            if (!this.registerInSelect) this.hideModal();
          }
          return;
        }

        const response = await TypePaymentService.create(this.typePayment);
        if (response.success) {
          this.addEvent({ name: "typePaymentSaved" });
          if (!this.registerInSelect) this.hideModal();
          if (this.registerInSelect) {
            this.$emit("input", {
              id: response.content.id,
              content: response.content.name,
            });
            this.hideVodal(this.formName);
          }
        }
      } finally {
        this.removeLoading(["btnSavePaymentType"]);
      }
    },
    update(data) {
      this.typePayment = new TypePayment();
      this.typePayment.update(data);
      this.removeLoading([data.id]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "typePaymentCreate") {
          this.resetValidation(this.formName);
          this.typePayment = new TypePayment();
        }
        if (event.name == "typePaymentUpdate") this.update(event.data);
      },
      deep: true,
    },
  },
};
</script>
